import {
    Grid
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { styleFind as style } from '../css/styleSheet';
import { removeAccents } from '../../../helpers/RemoveAccents';

    const SearcherEvaluationModel =({
        initialRows,
        setFilteredRows,
        label = "Buscar modelo",   
        width = 420,    
    }:any ) => {
    
        const handleChange = (searchTerm: string) => {
            if (searchTerm === '') {
              setFilteredRows(initialRows);
            } else {
              const filtered = initialRows.filter((model: { name: string; }) =>
                removeAccents(model.name.toLowerCase()).includes(removeAccents(searchTerm.toLowerCase()))
              );
              setFilteredRows(filtered);
            }
          };  

    return (
        <Grid item>
            <Box >
                <Grid
                    container
                    direction="row"
                    style={{...style.containerSearcher, width: width}}
                >
                    <Grid item >
                        <input
                            style={{...style.inputSearcher, width: (width - 100)}}
                            className="collaboratorTab__searcher"
                             placeholder={label}
                             onChange={(e) => handleChange(e.target.value)}
                        />
                    </Grid>

                    <Grid item style={{
                        width: "20px",
                        padding: "0 20px 0 40px",
                        color: "#7f7f81",
                        fontStyle: "bold",
                    }}>
                        <img
                            src="/assets/icons/icono-buscar.svg"
                            alt="Buscar"
                        />
                    </Grid>

                </Grid>
            </Box>
        </Grid>

    )
};

export default SearcherEvaluationModel
